import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import SocialLInks from '../SocialLInks/SocialLInks';
import styles from './MainFooter.module.css';

const currentYear = new Date().getFullYear();

const Footer = (props) => {
  const { userData } = props;
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerInfo}>
          <Link className={styles.logo} to="/" />
          <div className={styles.infoText}>
            Let&apos;s create a meal plan for you.
          </div>
          <div className={styles.copyright}>
            © MealWell {currentYear}
          </div>
        </div>
        <div className={styles.footerLinks}>
          <Link className={styles.footerLink} to="/blog">
            Blog
          </Link>
          <Link 
            className={styles.footerLink} 
            to="/contact"
          >
            Contacts
          </Link>
          {!userData && (
            <Link className={styles.footerLink} to="/get-meal-plan">
              Get your meal plan
            </Link>
          )}
          <a 
            className={styles.footerLink} 
            href="/terms"
            target="_blank"
            rel="noreferrer"
          >
            Terms & Conditions
          </a>
          <a 
            className={styles.footerLink} 
            href="/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy policy
          </a>
        </div>
        <div className={cn(styles.footerLinks, styles.iosLinks)}>
          <Link className={styles.linksTitle} to="/get-app">
            Get App
          </Link>
          <a 
            className={styles.appStore} 
            href="https://apps.apple.com/gb/app/mealwell-diet-food-planner/id6743499265"
            target="_blank"
            rel="noreferrer"
          />
        </div>
        <SocialLInks />
      </div>
    </footer>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
});

export default connect(mapStateToProps)(Footer);